<!-- 
This is a Vue.js component for a login page that allows the user to log in either using a Google account or by entering a username and password manually.

The template defines the layout of the page using HTML and CSS, including a title, form fields for entering a username and password, a Google sign-in button, and a "Sign up" link that directs users to the sign-up page.

The script section contains the code for the Vue.js component, which uses Axios to make a REST API call to authenticate the user's credentials when the user submits the login form. If the authentication is successful, the component saves the user's token and username to the local storage, sets the appropriate Vuex store state, and redirects the user to the wishboard list page.

There is also code commented out for logging out a user and for handling the onsuccess event when a user signs in using the Google sign-in button, but they are not currently used in the component.
-->
<template>
<!-- <body style="margin:0; padding:0;"> -->
    
    <div class="page-sign-up" style="margin-top: 100px; margin-left: 40px; margin-right: 40px; "> 
        <!-- Was id="app", a second element sharing that id with the Vue root that
             main.js renders. Duplicate ids make #app selectors ambiguous, and any
             global rule targeting #app matched this wrapper as well as the whole
             application. Nothing here referenced the id, so it is simply removed. -->
        <div class="login-panel">
        <div class="columns">
            <div class="column is-4 is-offset-4">
                <h4 class="title column is-5 is-offset-5">Login</h4>
                <div class="field">
                    <div class="control">
                        <div id="buttonDiv"> </div>
                        <!-- div id="google-signin-btn" class="g-signin2" data-onsuccess="onSignIn"></div -->
                        <div id="g_id_onload">
                            <!--                             data-client_id="460331473063-ngt52j4d1sbfbk0saa5uhhvlouoolrkd.apps.googleusercontent.com"
                            data-callback="this.onSignIn" -->
                        </div>
                    </div>
                </div>
                <form @submit.prevent="submitForm">
                    <div class="notification is-danger" v-if="errors.length">
                        <p v-for="error in errors" v-bind:key="error"> {{ error }} </p>
                    </div>
                </form>                    
            </div>
        </div>
    </div>
    </div>
    <!-- </body> -->
</template>

<script>
// import axios from 'axios'
import axios from '../axiosConfig'
import { toast } from 'bulma-toast'

export default {
        name: 'Login',
        data() {
            return {
                isActive: false,
                username: '',
                password: '',
                errors: []
            }
        },    
        
        mounted() { 

            // let googleSignIn = document.createElement('script')
            // googleSignIn.setAttribute('src', 'https://accounts.google.com/gsi/client')
            // document.head.appendChild(googleSignIn)

            document.title = 'Log In | Wishboard'
            this.emitter.emit('showme', 'true');
            this.emitter.emit('showWishboardCreate', 'false');
            this.emitter.emit('showlogout', 'false');
            // this.$root.$emit('showme', true);
            // this.$store.commit('showme', 'false')
            localStorage.setItem("showme",'false');                
            console.log('showme emitted');


            const initGoogle = () => {
                if (window._gsiInitialized) return;
                window._gsiInitialized = true;
                google.accounts.id.initialize({
                    client_id: "506599619709-p02eujal7re1e6dvq9dpfd2u1vo047ce.apps.googleusercontent.com",
                    auto_select: true,
                    callback: this.onSignIn
                });
                google.accounts.id.renderButton(
                    document.getElementById("g_id_onload"),
                    { theme: "outline", size: "large" }
                );
                // No google.accounts.id.prompt(). One Tap auto-prompting on a login
                // page makes Google show the FedCM consent screen -- "thewishboard.com
                // wants to access other apps and services on this device" -- which is
                // expected behaviour but an alarming thing to put in front of someone
                // who just wants to sign in. The rendered button offers the same
                // one-click sign-in without the interstitial.
            };

            // GSI script may still be loading (async defer in index.html) — wait for it
            if (typeof google !== 'undefined' && google.accounts) {
                initGoogle();
            } else {
                const gsiScript = document.querySelector('script[src*="accounts.google.com/gsi/client"]');
                if (gsiScript) {
                    gsiScript.addEventListener('load', initGoogle);
                }
            }



            //  gapi.load('auth2', () => {
            //      gapi.signin2.render('google-signin-btn', { // this is the button "id"
            //         prompt: 'select_account',
            //         onsuccess: this.onSignIn, 
            //         onfailure: this.failed
            //     }) 
            //  }) 
        }, 
        beforeUnmount() {
            window._gsiInitialized = false;
        },
        methods: {
            failed(msg){
                console.log('error: ' + msg);
            },

            // logout(){
            //     var auth2 = gapi.auth2.getAuthInstance();
            //     auth2.signOut().then(function () {
            //         console.log('User signed out.');
            //     });
            // },

            //loginRestCall(formData){
            async loginRestCall(formData) {
                try {
                    const response = await axios.post("/api/v1/token/login/", formData);

                    if (response.status === 200) {
                        // Handle successful login
                        const token = JSON.stringify('Token ' + response.data["auth_token"]);
                        localStorage.setItem("token", token);

                        toast({
                            message: 'Logged in ' + response.data["auth_token"],
                            type: 'is-success',
                            dismissible: true,
                            pauseOnHover: true,
                            duration: 5000,
                            position: 'bottom-center'
                        });

                        this.$store.commit('setToken', token);

                        const userResponse = await axios.get("/api/v1/users/me/", {
                            headers: {
                                'Authorization': token
                            }
                        });

                        if (userResponse.status === 200) {
                            console.log('Success 200');
                            const username = userResponse.data["username"];
                            localStorage.setItem("username", username);
                            this.$store.commit('setUser', username);
                            this.$router.push('Wishboardlist');
                        } else {
                            console.error('Error retrieving user information:', userResponse.status);
                        }
                    } else {
                        console.error('Error logging in:', response.status);
                    }
                } catch (error) {
                        if (error.response) {
                        for (const property in error.response.data) {
                            this.errors.push(`${(property)}: ${error.response.data[property]}`);
                        }
                        console.error(JSON.stringify(error.response.data));
                    } else if (error.message) {
                        this.errors.push(error.message);
                        console.error(JSON.stringify(error));
                    }
                }
            },

            onSignIn(googleUser){
                var gtoken = googleUser.credential;
                const decodedPayload = atob(gtoken.split('.')[1]);
                const payload = JSON.parse(decodedPayload);
                const email = payload.email;
                const username = payload.name;

                console.log('Email:', email);
                console.log('Username:', username);

                localStorage.setItem("username", username);   
                this.$store.commit('setUser', email); 
                this.$store.commit('setGToken', gtoken);          
                console.log('google signed in !!!!')

                // If we were redirected here from a protected page, go back there
                const redirect = this.$route.query.redirect
                if (redirect) {
                    this.$router.push(redirect)
                } else {
                    // Leading slash matters: vue-router 4 treats a string without
                    // one as relative to the current route. From /login it happens
                    // to resolve to /Wishboardlist, but from any deeper path it
                    // would not.
                    this.$router.push('/Wishboardlist')
                }
            },
            
        }
}


</script>
